import React from 'react';
import PropTypes from 'prop-types';

import { DeviceProvider } from '@codex-brightworld/gadgets';
import { BoxSizing } from '@codex-brightworld/basics';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';
import { Bundle } from '@codex-applications-brightworld/bundles';
import translations from '@dc/ui-library/src/config/translations';

import AddToBasketButtonForStaticBundle from './AddToBasketButtonForStaticBundle';


const StaticBundle = ({
  id, addons, bundleType, createdDate, discountLabel, heading, priceDescription,
  product, totalPrice, totalSavings, psaVariant
}) => (
  <EnvironmentThemeProvider>
    <DeviceProvider>
      <BoxSizing>
        <Bundle
          id={id}
          addons={addons}
          bundleType={bundleType}
          dateCreated={createdDate}
          discountLabel={discountLabel}
          heading={heading}
          priceDescription={priceDescription}
          product={product}
          translations={{
            created: translations['bundle.created'],
            mainProductHint: translations['bundle.main_product_hint'],
            save: translations['bundle.save_prefix'],
            total: translations['bundle.total'],
            totalSavings: translations['bundle.total_savings']
          }}
          totalPrice={totalPrice}
          totalSaving={totalSavings}
        >
          <AddToBasketButtonForStaticBundle
            psaVariant={psaVariant}
            id={id}
            product={product}
            addons={addons}
            totalPrice={totalPrice}
            buttonLabel={translations['bundle.add_to_basket']}
            bundleType={bundleType}
          />
        </Bundle>
      </BoxSizing>
    </DeviceProvider>
  </EnvironmentThemeProvider>
);

StaticBundle.propTypes = {

  id: PropTypes.string.isRequired,
  addons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      segmentId: PropTypes.number
    })
  ).isRequired,
  bundleType: PropTypes.string,
  createdDate: PropTypes.string,
  discountLabel: PropTypes.string,
  heading: PropTypes.string,
  priceDescription: PropTypes.string,
  product: PropTypes.shape({
    id: PropTypes.string,
    segmentId: PropTypes.number
  }).isRequired,
  totalPrice: PropTypes.string,
  totalSavings: PropTypes.string,
  psaVariant: PropTypes.string,
  buttonLabel: PropTypes.string
};

StaticBundle.defaultProps = {
  bundleType: '',
  createdDate: '',
  discountLabel: '',
  heading: '',
  priceDescription: '',
  totalPrice: '',
  totalSavings: '',
  psaVariant: null,
  buttonLabel: ''
};

export default StaticBundle;
